import { Injectable } from '@angular/core';
import { ApiEntityStore } from '@core/api/api-entity-store';
import { Language } from '@core/models/partner.model';
import { EntityState, StoreConfig } from '@datorama/akita';

export interface LanguageState extends EntityState<Language> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'partnersOverview', resettable: true })
export class LanguageStore extends ApiEntityStore<LanguageState> {
  constructor() {
    super();
  }
}
